import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function Notification(props) {
  return (
    <Svg
      {...props}
      width={props.diameter || "100"}
      height={props.diameter || "100"}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Circle
        cx="50"
        cy="50"
        r="50"
        fill="rgba(255, 122, 0, 0.05)"
        fill-opacity="0.05"
      />
      <Path
        d="M50.1872 64.294C44.8923 64.294 39.5974 64.294 34.3026 64.294C33.7731 64.294 33.2247 64.294 32.7141 64.1617C31.4093 63.8213 30.4449 63.027 30.1234 61.6844C29.783 60.304 30.1423 59.0559 31.258 58.0915C33.7163 55.9357 35.2859 53.2883 35.8532 50.0546C36.1747 48.2392 36.0801 46.4049 36.0801 44.5896C36.0801 42.3582 36.0045 40.1267 36.6663 37.9332C38.217 32.7328 43.1904 28.5915 48.5798 28.1187C49.2416 28.062 49.9035 28.0242 50.5654 28.0053C51.2461 27.9675 51.492 28.1187 51.1894 28.913C48.2772 36.3636 51.9836 44.5517 59.491 47.3505C60.7958 47.8421 62.1573 48.1258 63.5378 48.1636C64.0673 48.1825 64.2942 48.2771 64.3509 48.8822C64.6913 52.5886 66.2987 55.6521 69.0974 58.1482C70.3455 59.2639 70.6858 60.7011 70.0996 62.0815C69.4567 63.5565 68.2653 64.294 66.658 64.294C61.1551 64.294 55.6711 64.294 50.1872 64.294Z"
        fill="#FF7A00"
        fill-opacity="0.8"
      />
      <Path
        d="M50.0926 66.3363C52.2673 66.3363 54.442 66.3742 56.5977 66.3174C57.4487 66.2985 57.5432 66.5822 57.2974 67.3197C55.7846 71.8203 50.2439 73.787 46.2349 71.2719C44.6086 70.2508 43.5497 68.8514 42.9256 67.0739C42.7176 66.4876 42.8689 66.3174 43.4929 66.3174C45.6865 66.3553 47.8801 66.3363 50.0926 66.3363Z"
        fill="#FF7A00"
        fill-opacity="0.5"
      />
      <Circle cx="63.5" cy="34.5" r="9.5" fill="#FF7A00" />
      <Path
        d="M63.9897 39.14C62.8043 39.14 61.927 38.6873 61.3577 37.782C60.7977 36.8767 60.5177 35.6167 60.5177 34.002C60.5177 32.9287 60.6297 32.0093 60.8537 31.244C61.087 30.4693 61.4557 29.8767 61.9597 29.466C62.473 29.0553 63.1497 28.85 63.9897 28.85C65.175 28.85 66.0523 29.3027 66.6217 30.208C67.2003 31.1133 67.4897 32.378 67.4897 34.002C67.4897 35.0753 67.373 35.9947 67.1397 36.76C66.9157 37.5253 66.547 38.1133 66.0337 38.524C65.5203 38.9347 64.839 39.14 63.9897 39.14ZM63.9897 37.236C64.419 37.236 64.713 36.97 64.8717 36.438C65.0397 35.8967 65.1237 35.0847 65.1237 34.002C65.1237 32.9287 65.0397 32.1213 64.8717 31.58C64.713 31.0387 64.419 30.768 63.9897 30.768C63.5697 30.768 63.2757 31.0387 63.1077 31.58C62.949 32.1213 62.8697 32.9287 62.8697 34.002C62.8697 35.0753 62.949 35.8827 63.1077 36.424C63.2757 36.9653 63.5697 37.236 63.9897 37.236Z"
        fill="white"
      />
    </Svg>
  );
}

export default Notification;
